module.exports = __webpack_public_path__ + "img/2-3.cc7b690.png";